const getters = {

    /**
     * set navigation bar to white
     *
     * @param {object} context
     * @returns {boolean}
     */
    navShouldBeWhite(context) {
        return [2, 3, 4].includes(context.activeSection);
    },
};

export default getters;
